import { theme } from '@/styles/theme';

export const styles = {
  container: {
    paddingTop: '32px',
  },
  requiredTitle: {
    fontSize: '16px',
    color: theme.palette.gray.main,
    fontWeight: 600,
  },
  requiredItems: {
    fontSize: '14px',
    color: theme.palette.gray.main,
    fontWeight: 400,
  },
  stackItems: {
    paddingTop: 1.5,
    paddingLeft: 2,
    gap: 1.5,
  },
  stackLineItems: {
    display: 'flex',
    gap: 1.5,
  },
  checkBox: {
    pointerEvents: 'auto',
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
  },
  checkBoxLabel: {
    gap: 0.7,
  },
  checkBoxWithText: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'start',
    },
  },
  checkBoxText: {
    fontSize: '1.2rem',
    fontWeight: 600,
    display: 'inline',
  },
  checkRedText: {
    color: 'red',
    fontSize: '1.2rem',
    fontWeight: 600,
    cursor: 'pointer',
  },
};
